
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MetaOverlay extends Vue {
  @Prop() public info: any;
  @Prop({ default: true }) public visible!: boolean;
}
